/* global axios */
import ApiClient from '../ApiClient';

// SiteUp (F2): regras de roteamento automático de agentes de IA. Um gatilho
// (etiqueta aplicada / etapa do Kanban) troca o assistente que atende a conversa.
// CRUD em /api/v1/accounts/:account_id/captain/routing_rules. As regras são da
// CONTA (target_assistant_id obrigatório; inbox_id opcional restringe a uma caixa).
class CaptainRoutingRules extends ApiClient {
  constructor() {
    super('captain/routing_rules', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(data = {}) {
    return axios.post(this.url, { routing_rule: data });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, { routing_rule: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CaptainRoutingRules();
